import type { z } from "@hono/zod-openapi";
import { tmsEventKind } from "../base";
import { formSubmissionRefs } from "../subjects/formSubmission/refs";

/**
 * The driver reported a problem with the unit's toll pass.
 */
export const tollPassIssueV1 = tmsEventKind(
  { category: "exception", kind: "tollPassIssue", version: 1 },
  { refs: formSubmissionRefs, facts: {} },
);

export const TollPassIssueV1Schema = tollPassIssueV1.schema;
export const TollPassIssueV1FactsSchema = tollPassIssueV1.facts;

export type TollPassIssueV1 = z.infer<typeof TollPassIssueV1Schema>;
export type TollPassIssueV1Facts = z.infer<typeof TollPassIssueV1FactsSchema>;

/** Every version of `tollPassIssue`, keyed by version. What `catalog.ts` places under `exception`. */
export const tollPassIssue = { 1: tollPassIssueV1 } as const;
